@if (!isLoading) {
  <microsec-card [isBordered]="true">
    <div class="flex flex-col gap-4">
      <label class="text-lg font-bold">Offline Tokens</label>
      <div class="w-full text-grey">
        <span>Offline tokens allow MicroIDS to execute background operations,&nbsp;</span>
        <span>such as MicroIDS Node connections and Workflow configurations,&nbsp;</span>
        <span>even when you are not actively logged in.</span>
      </div>
      <div class="flex items-center gap-4">
        <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
          <p-button
            label="Generate New Token"
            severity="primary"
            [rounded]="true"
            icon="fa fa-plus"
            [style]="{ 'text-transform': 'none' }"
            [disabled]="!isValidLicense()"
            (onClick)="openPasswordConfirmationForm()" />
        </div>
        <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
          <p-button
            label="Revoke All Tokens"
            severity="danger"
            [rounded]="true"
            icon="fa fa-trash"
            [style]="{ 'text-transform': 'none' }"
            [disabled]="!isValidLicense() || !tokens.length"
            (onClick)="confirmAllTokensRevocation()" />
        </div>
      </div>
    </div>
  </microsec-card>
}
